import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "SizeFull",
  "use": "SizeFull-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SizeFull\"><path fill-rule=\"evenodd\" d=\"M45.286 1H63v17.714h-8.857V9.857h-8.857V1zM18.714 1H1v17.714h8.857V9.857h8.857V1zm26.572 62H63V45.286h-8.857v8.857h-8.857V63zm-26.572 0H1V45.286h8.857v8.857h8.857V63z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol